import React from 'react';
import { Instagram, Facebook, Youtube, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16 border-b border-gray-800 pb-12">
          
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-white/5 rounded-[12px] flex items-center justify-center border border-white/10 backdrop-blur-sm shadow-inner">
                    <img 
                      src="logo.png" 
                      alt="Swaram Academy Logo" 
                      className="h-6 w-6 object-contain opacity-90" 
                    />
                </div>
                <span className="font-display text-2xl tracking-widest font-semibold uppercase">
                    Swaram Academy
                </span>
            </div>
            <p className="text-gray-400 font-light leading-relaxed max-w-sm">
              Dedicated to preserving the sanctity and tradition of Carnatic music. Join us in this divine journey of swaras and laya.
            </p>
            <div className="flex gap-4 mt-8">
                <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-royal-maroon hover:text-white transition-all"><Instagram size={18} /></a>
                <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-royal-maroon hover:text-white transition-all"><Facebook size={18} /></a>
                <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-royal-maroon hover:text-white transition-all"><Youtube size={18} /></a>
                <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-royal-maroon hover:text-white transition-all"><Twitter size={18} /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg mb-6 text-gray-200">Quick Links</h4>
            <ul className="space-y-4">
              <li><a href="#about" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">About Us</a></li>
              <li><a href="#curriculum" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">Curriculum</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">Testimonials</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg mb-6 text-gray-200">Legal</h4>
            <ul className="space-y-4">
              <li><a href="#" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">Terms of Service</a></li>
              <li><a href="#" className="text-gray-400 hover:text-royal-maroon transition-colors font-light">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm font-light">
            <p>&copy; {new Date().getFullYear()} Swaram Academy. All rights reserved.</p>
            <p className="mt-2 md:mt-0">Designed with devotion.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;